
import $ from 'jquery';
import slick from 'slick-carousel';

const clientCarouselElement = $('.client.list ul');

    /**
     * @brief [brief description]
     * @details [long description]
     * @return [description]
     */
    const rtn = function() {


        if (clientCarouselElement.length > 0) {

            var carousel = clientCarouselElement.slick({
                autoplay: true,
                arrows: false,
                variableWidth: true,
                prevArrow: false,
                nextArrow: false,
                centerMode: false,
                initialSlide: 4
            });

        }
    }


    module.exports = rtn;


// WEBPACK FOOTER //
// ./js/service/animate-client-carousel.js